import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { ArrowBackIosNew } from "@mui/icons-material";
import { FormControlLabel, Link, Radio, RadioGroup, Stack, Typography as T } from "@mui/material";
import useIsMasterDataset from "datasets/hooks/useIsMasterDataset";
import IngestForm from "datasets/pages/tables/components/IngestForm";
import SnowflakeForm from "datasets/pages/tables/components/SnowflakeForm";
import { IngestProvider } from "datasets/pages/tables/contexts/ingest";
import { TableAccessLevel } from "datasets/types/enums/access-level";
import PageHeader from "~/components/PageHeader";

const AddTable = () => {
  const isMasterDataset = useIsMasterDataset();
  const [dataLocation, setDataLocation] = useState("cloud");

  return (
    <Stack gap={1.5}>
      <Stack gap={1}>
        <Link
          component={RouterLink}
          underline="hover"
          color="text.primary"
          to=".."
          sx={{
            opacity: 0.6,
            textDecoration: "none",
            fontSize: 14,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <ArrowBackIosNew fontSize="inherit" />
          All Tables
        </Link>
        <PageHeader>Add Table</PageHeader>
      </Stack>
      <Stack gap={1}>
        {!isMasterDataset && (
          <>
            <T variant="body2" fontWeight={500}>
              Where is your data located?
            </T>
            <RadioGroup
              row
              sx={{ gap: 1 }}
              value={dataLocation}
              onChange={(e) => setDataLocation(e.currentTarget.value)}
            >
              <FormControlLabel value="cloud" control={<Radio size="small" />} label="From File" />
              <FormControlLabel
                value="database"
                control={<Radio size="small" />}
                label="Database"
              />
            </RadioGroup>
          </>
        )}
      </Stack>
      {dataLocation === "cloud" && (
        <IngestProvider>
          <IngestForm />
        </IngestProvider>
      )}
      {dataLocation === "database" && <SnowflakeForm accessLevel={TableAccessLevel.WRITE} />}
    </Stack>
  );
};

export default AddTable;
